import { Text } from '@chakra-ui/react'
import { ColumnDef } from '@tanstack/react-table'
import { useMemo } from 'react'

import { AuditLog } from '../../../services/auditService'
import { formatAdminDateTime } from '../../../utils/dates'

export const useAuditAdminColumns = (): ColumnDef<AuditLog>[] =>
  useMemo(
    () => [
      {
        accessorKey: 'createdDate',
        header: 'Date',
        cell: info => (
          <Text whiteSpace="nowrap">
            {formatAdminDateTime(info.getValue() as string) ?? '—'}
          </Text>
        ),
        meta: {
          toText: val => formatAdminDateTime(val as string) ?? '—',
        },
      },
      {
        accessorKey: 'kind',
        header: 'Kind',
        cell: info => (
          <Text fontFamily="mono" fontSize="xs">
            {info.getValue() as string}
          </Text>
        ),
        meta: {
          toText: val => val as string,
        },
      },
      {
        id: 'user',
        header: 'User',
        accessorFn: row => row.user?.name ?? row.user?.email ?? row.userId,
        cell: info => <Text fontSize="sm">{info.getValue() as string}</Text>,
        meta: {
          toText: val => val as string,
        },
      },
      {
        accessorKey: 'description',
        header: 'Description',
        cell: info => (
          <Text
            maxW="320px"
            isTruncated
            title={(info.getValue() as string) ?? undefined}
          >
            {(info.getValue() as string) ?? '—'}
          </Text>
        ),
        meta: {
          toText: val => (val as string) ?? '—',
        },
      },
      {
        id: 'subject',
        header: 'Subject',
        accessorFn: row =>
          row.subjectType && row.subjectId
            ? `${row.subjectType} ${row.subjectId.slice(0, 8)}…`
            : '—',
        cell: info => (
          <Text fontSize="xs" color="presets.neutral.70">
            {info.getValue() as string}
          </Text>
        ),
        meta: {
          toText: val => val as string,
        },
      },
    ],
    [],
  )
